// extracted by mini-css-extract-plugin
export default {"burger-menu-item":"burger-nav-item_burger-menu-item__Ve-wz","burger-menu-link":"burger-nav-item_burger-menu-link__Gd252"};